import { useCallback, useState } from 'react'
import { type ColorChangeHandler, SketchPicker } from 'react-color'

interface ColorInputProps {
  defaultValue: string
  placeholder?: string
  predefinedColors?: string[]
  onChange: (color: string) => void
  className?: string
}

const ColorInput = ({
  defaultValue,
  placeholder,
  predefinedColors = [],
  onChange,
  className,
}: ColorInputProps) => {
  const [showColorPicker, setShowColorPicker] = useState<boolean>(false)
  const [color, setColor] = useState<string>(defaultValue)

  const handleColorChange: ColorChangeHandler = useCallback(
    (color) => {
      setColor(color.hex)
      onChange(color.hex)
    },
    [onChange, setColor],
  )

  return (
    <div className={className}>
      <div
        onClick={() => {
          setShowColorPicker(
            (currentShowColorPicker) => !currentShowColorPicker,
          )
        }}
        className="relative overflow-hidden inline-block p-1.5 pl-10 pr-3 border border-input-border rounded-sm text-xs leading-5 cursor-pointer"
      >
        <div
          className="absolute top-0 bottom-0 left-0 w-[30px] border-r border-input-border"
          style={{
            backgroundColor: color,
          }}
        />
        {placeholder}
      </div>

      {showColorPicker && (
        <div className="absolute py-4 z-10">
          <div
            onClick={() => {
              setShowColorPicker(false)
            }}
            className="fixed top-0 right-0 bottom-0 left-0"
          />
          <SketchPicker
            color={color}
            disableAlpha
            width="320px"
            presetColors={predefinedColors}
            onChange={handleColorChange}
          />
        </div>
      )}
    </div>
  )
}

export default ColorInput
